import { redirect } from 'react-router-dom';
import { checkAuth, checkAdminRole, checkAgencyRole } from './authUtils';

/**
 * Loader for protected routes
 * Checks if user is authenticated, redirects to /login if not
 * @returns null if authenticated, Response (redirect) if not
 */
export function protectedLoader(): Response | null {
  if (!checkAuth()) {
    return redirect('/login');
  }
  return null;
}

/**
 * Loader for admin-only routes
 * Checks if user is authenticated and has admin role
 * Redirects to /login if not authenticated, /dashboard if not admin
 * @returns null if authorized, Response (redirect) if not
 */
export function adminLoader(): Response | null {
  if (!checkAuth()) {
    return redirect('/login');
  }
  
  if (!checkAdminRole()) {
    return redirect('/dashboard');
  }
  
  return null;
}

/**
 * Loader for agency-only routes
 * Checks if user is authenticated and has agency role
 * Redirects to /login if not authenticated, /dashboard if not agency
 * @returns null if authorized, Response (redirect) if not
 */
export function agencyLoader(): Response | null {
  if (!checkAuth()) {
    return redirect('/login');
  }
  
  if (!checkAgencyRole()) {
    return redirect('/dashboard');
  }
  
  return null;
}

